/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     requestUtils
//   Details:    Request utils constant
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 103839 06/04/20 JC       New
// 115164 12/10/21 JC  M02JC	Added day parts, hours
// WI2232 25/01/23 JC  M03JC    Added SpecificDays
// WI2242 26/01/23 JC  M04JC    Added isAmendingApproved
// WI4743 25/02/25 JC  M05JC    Handle working times 
//-------------------------------------------------------
*/
import moment from 'moment'; //M01JC
import { requestTypes } from '../constants/RequestTypes';
import { dayPartEnum } from '../constants/DayPartEnum'; //M02JC

export const requestUtils = {
    getStateObject,
    buildSpecificDays //M03JC
};

function getStateObject(props) {
    const { request } = props;
    const { copyfromid } = props.match.params; //M05JC
    const hasCopyFromId = copyfromid !== undefined && copyfromid > 0;//M05JC

    let absenceReasonId = "";
    let sites = [];
    let specificDays = []; //M03JC
    
    if (request) {
        if (request.absenceReasons) {
            absenceReasonId = request.absenceReasons.filter((item, i) => {
                return item.isSelected;
            });

            if (absenceReasonId.length > 0)
                absenceReasonId = absenceReasonId[0].absenceReasonId;
            else
                absenceReasonId = "";
        }

        sites = request.sites.map((item, i) => {
            return { siteId: item.siteId, site: item.site, isSelected: item.isSelected };
        });

        //M03JC build specific days
        specificDays = buildSpecificDays(request.isSpecificDays, specificDays, moment.utc(request.fromDate).toDate(), moment.utc(request.toDate).toDate());
    }

    //M05JC moved above return...
    let id = request ? request.id : 0;
    let canAmend = request ? request.canAmend : false;
    let canCancel = request ? request.canCancel : false;
    let canAcknowledge = request ? request.canAcknowledge : false;
    let canChange = request ? request.canChange : false;

    //M05JC...
    let workingTimes = undefined;
    let hasWorkingTimes = false;
    let workingTimeLength = 0;
    if (request && request.workingTimes && request.workingTimes.length > 0) {
        workingTimes = request.workingTimes;
        hasWorkingTimes = true;
        workingTimeLength = request.workingTimes.length;
    }
    let showWorkingTimes = props.fromCalendar && canAmend && id === 0 && !hasCopyFromId && hasWorkingTimes; //show working times by default if from the calendar, new, not copying and with working times
    let showWorkingTimesButton = props.fromCalendar && hasWorkingTimes; //show working times buttong if from calendar & has working times
    let showRequest = !showWorkingTimes;
    let showRequestButton = showWorkingTimesButton; //show a request button if we've got a working times button

    return {
        id, //M05JC moved logic above
        timestamp: request ? request.timestamp : 0,
        requestTypeId: request ? request.requestTypeId : requestTypes.holiday,
        fromDate: request ? moment.utc(request.fromDate).toDate() : undefined,
        toDate: request ? moment.utc(request.toDate).toDate() : undefined,
        isSpecificDays: request ? request.isSpecificDays : false, //M03JC
        specificDays: specificDays, //M03JC
        sites,
        absenceReasonId,
        requestNote: request ? (request.requestNote || "") : "",
        requestType: request ? (request.requestType || "") : "",
        requestStatus: request ? (request.requestStatus || "") : "",
        processedNote: request ? (request.processedNote || "") : "",
        requestStatusEnum: request ? (request.requestStatusEnum || 1) : 1,
        dayPart: request ? request.dayPart : dayPartEnum.full_day, //M02JC
        hours: request ? request.hours : 0, //M02JC

        canAmend, //M05JC moved logic above
        canCancel, //M05JC moved logic above
        canAcknowledge, //M05JC moved logic above
        canChange, //M05JC moved logic above
        showCancelDialog: false,
        fromCalendar: props.fromCalendar, //M05JC 
        editingHours: false, //M07JC
        isAmendingApproved: request ? request.isAmendingApproved : false, //M04JC

        //M05JC working times etc....
        workingTimes, hasWorkingTimes, workingTimeLength, showWorkingTimes, showWorkingTimesButton,
        showRequest, showRequestButton
    };
}

function buildSpecificDays(isSpecificDays, specificDays, fromDate, toDate) {
    let specificDaysReturn = []; //M03JC

    //if using specific days
    if (isSpecificDays) {

        let workingDate = moment.utc(fromDate);
        do {
            //determine if included, defaulting to true
            let bisIncluded = true;

            //is there a specific day for it already?
            specificDays.forEach(function (specificDay) {
                if (moment.utc(specificDay.specificDate).isSame(workingDate)) {
                    //get the included value
                    bisIncluded = specificDay.isIncluded;
                }
            });

            //construct new specific day
            specificDaysReturn.push(
                {
                    specificDate: workingDate.toDate(),
                    isIncluded: bisIncluded
                }
            );

            //increment the date & count
            workingDate = workingDate.add(1, 'days');
        }
        //while the from date's not after the to date
        while (!workingDate.isAfter(moment.utc(toDate)));
    }

    //return
    return specificDaysReturn;
}